import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M983.727059,5.42117647 L1723.04,353.618824 C1742.80471,362.992941 1755.45412,382.870588 1755.45412,404.781176 L1755.45412,1006.30588 C1755.45412,1495.90588 1331.24706,1726.08 1021.67529,1894.24941 L986.776471,1913.22353 C978.305882,1917.74118 969.044706,1920.11294 959.670588,1920.11294 C950.409412,1920.11294 941.148235,1917.74118 932.677647,1913.22353 L897.778824,1894.24941 C588.094118,1726.08 164,1495.90588 164,1006.30588 L164,404.781176 C164,382.870588 176.649412,362.992941 196.414118,353.618824 L935.727059,5.42117647 C950.861176,-1.80705882 968.592941,-1.80705882 983.727059,5.42117647 Z M757.088,383.322353 C581.012706,383.322353 437.803294,526.644706 437.803294,702.72 C437.803294,878.795294 581.012706,1022.00471 757.088,1022.00471 C759.008,1022.00471 760.928,1022.00471 762.848,1021.89176 L762.848,1021.89176 L821.351529,1080.39529 L905.040941,1080.39529 L905.040941,1197.17647 L1021.82212,1197.17647 L1021.82212,1280.97882 L1113.41741,1372.46118 L1426.82918,1372.46118 L1426.82918,1059.04941 L1076.25976,708.367059 C1076.37271,706.56 1076.37271,704.64 1076.37271,702.72 C1076.37271,526.644706 933.163294,383.322353 757.088,383.322353 Z M757.088,496.263529 C870.819765,496.263529 963.431529,588.988235 962.415059,712.884706 L962.415059,712.884706 L958.462118,750.155294 L1313.888,1105.80706 L1313.888,1259.52 L1160.17506,1259.52 L1134.76329,1234.22118 L1134.76329,1084.23529 L1017.98212,1084.23529 L1017.98212,967.454118 L868.109176,967.454118 L804.297412,903.755294 L757.088,909.063529 C643.356235,909.063529 550.744471,816.564706 550.744471,702.72 C550.744471,588.988235 643.356235,496.263529 757.088,496.263529 Z M762.068706,621.244235 C715.311059,621.244235 677.362824,659.192471 677.362824,705.950118 C677.362824,752.707765 715.311059,790.656 762.068706,790.656 C808.826353,790.656 846.774588,752.707765 846.774588,705.950118 C846.774588,659.192471 808.826353,621.244235 762.068706,621.244235 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAdminSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAdminSolid, _Component);

  var _super = _createSuper(IconAdminSolid);

  function IconAdminSolid() {
    _classCallCheck(this, IconAdminSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAdminSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAdmin",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAdminSolid.displayName = "IconAdminSolid";
  return IconAdminSolid;
}(Component);

IconAdminSolid.glyphName = 'admin';
IconAdminSolid.variant = 'Solid';
IconAdminSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAdminSolid;
export { IconAdminSolid };